export default __webpack_public_path__ + "static/SamsungSharpSans-769f64ac016899cfcaa1520e753416aa.woff";